/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import { NameWithLink } from "~/components/Tables/cells/NameWithLink";
import {
  MediumColumn,
  MediumIconColumn,
  FlexColumnMax,
} from "~/components/Tables/styles";
import { ROUTES } from "~/routing/routes";
import { NextDateCell } from "~/views/plans/PlansTable/NextDateCell";
import { Plan } from "~/views/plans/PlansTable/PlansTableColumns";
import { PlanStateIconCell } from "~/views/plans/PlansTable/PlanStateIconCell";

const columnHelper = createColumnHelper<Plan>();

export function columns() {
  return [
    columnHelper.accessor(() => null, {
      id: "color",
      header: () => null,
      cell: ({ row }) => {
        return (
          <PlanStateIconCell
            enabled={row.original.enabled}
            cronExpression={row.original.scheduleCron}
            scheduleExecutionDates={row.original.scheduleExecutionDates}
          />
        );
      },
      meta: MediumIconColumn,
    }),
    columnHelper.accessor((row) => row?.name, {
      header: "Plan Name",
      cell: ({ row }) => (
        <NameWithLink
          name={row.original.name}
          link={ROUTES.plans.generateDetails(row.original.id)}
        />
      ),
      meta: FlexColumnMax,
    }),
    columnHelper.accessor((row) => row?.name, {
      header: "Next Execution (local time)",
      cell: ({ row }) => {
        return NextDateCell({
          cronExpression: row.original.scheduleCron,
          timezone:
            row.original.scheduleTimezone &&
            Intl.DateTimeFormat().resolvedOptions().timeZone,
          scheduleExecutionDates: row.original.scheduleExecutionDates,
          nextExecutionDates: row.original.nextExecutionDates,
          scheduleOffset: row.original.scheduleOffset,
        });
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor((row) => row?.name, {
      header: "Next Execution (plan time)",
      cell: ({ row }) => {
        return NextDateCell({
          cronExpression: row.original.scheduleCron,
          timezone: row.original.scheduleTimezone,
          scheduleExecutionDates: row.original.scheduleExecutionDates,
          nextExecutionDates: row.original.nextExecutionDates,
          scheduleOffset: row.original.scheduleOffset,
        });
      },
      meta: MediumColumn,
    }),
  ] as never;
}
